import { Box } from "@/components/ui/box";
import DateRangeFilterSelect from "@/components/ui/custom/DateRangeFilterSelect";
import { MonthRangeFilter } from "@/components/ui/custom/MonthRangeFilter";
import { ReactNode, useState } from "react";
import { RangePeriod } from "./dashboard";

interface SectionCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  filterSlot?: ReactNode;
  className?: string;
}

export default function SectionCard({
  title,
  description,
  children,
  filterSlot,
  className = "",
}: SectionCardProps) {
  const [rangePeriod, setRangePeriod] = useState<RangePeriod | undefined>(
    () => {
      // Set default to Last Month (1 month ago from today) to match MonthRangeFilter default
      const now = new Date();
      const oneMonthAgo = new Date(now);
      oneMonthAgo.setMonth(now.getMonth() - 1);

      // Set time boundaries
      oneMonthAgo.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);

      return {
        start: oneMonthAgo,
        end: now,
      };
    }
  );

  return (
    <div className={`bg-white rounded-xl shadow-sm p-4 ${className}`}>
      <Box className="w-full flex flex-row flex-wrap gap-4 justify-between">
        <Box className="flex flex-col">
          <h3 className="text-lg font-semibold">{title}</h3>
          {description && (
            <h5 className="text-sm font-normal text-[#6E6E6E]">
              {description}
            </h5>
          )}
        </Box>

        {filterSlot && <Box className="w-full">{filterSlot}</Box>}
      </Box>

      {children}
    </div>
  );
}
